import { Button } from "@resource/atlas/button/Button";
import { atlasCamera } from "@resource/atlas/icons";
import { useLogEvent } from "analytics";
import { useReplaceImageData } from "client/guide-content/rich-blocks/utils";
import clsx from "clsx";
import { V2GuideEditorContextProviderType } from "components/GuideEditor/V2GuideEditorContext";
import { useState } from "react";

interface GuideBannerProps {
  bannerUrl: string | null;
  color?: string;
  stretch?: boolean;
  onUpdateBannerUrl?: (imageUrl: string) => void;
}

function isValidHexColor(input: string): boolean {
  const hexColorRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
  return hexColorRegex.test(input);
}

function GuideBanner({
  bannerUrl,
  color,
  stretch,
  onUpdateBannerUrl,
}: GuideBannerProps) {
  const bannerColor = color && isValidHexColor(color) ? color : "#7348FF";
  const { fileChooserInput, onReplaceImage } = useReplaceImageData();
  const [isBannerHovered, setIsBannerHovered] = useState(false);
  const logEvent = useLogEvent({
    project: "Include brand kit in our guide templates",
    component: "Banner",
  });

  return (
    <>
      {fileChooserInput}
      <div
        className="relative"
        onMouseEnter={() => setIsBannerHovered(true)}
        onMouseLeave={() => setIsBannerHovered(false)}
      >
        <div
          className={clsx({
            "-mx-4 lg:-mx-8": stretch,
            "w-full": !stretch,
          })}
        >
          <div
            className={clsx(
              "relative min-[42rem]:rounded-md",
              "h-0 w-full pt-[25%] bg-center bg-cover aspect-[1200/300]"
            )}
            style={{
              backgroundImage: `url(${bannerUrl})`,
              backgroundColor: bannerColor,
            }}
          />
          {onUpdateBannerUrl && (
            <div
              className={`absolute top-0 right-0 pt-4 -mr-4 ${
                isBannerHovered ? "opacity-100" : "opacity-0"
              }`}
            >
              <Button
                icon={atlasCamera}
                variant="default"
                size="small"
                onClick={() => {
                  logEvent("Edit Cover Image Clicked", {
                    entity: V2GuideEditorContextProviderType.GUIDE,
                  });
                  onReplaceImage((imageUrl: string) =>
                    onUpdateBannerUrl?.(imageUrl)
                  );
                }}
              >
                Edit cover image
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default GuideBanner;
